import { createApp } from 'vue';
import GetTalentReportForm from '../../../wealth/GetTlntReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-wealth-form-view')
Array.from(appElements).forEach(element => {
    createApp(GetTalentReportForm).mount(element);
});